function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".gpsa{fill:#3b3b3b;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1542.292 -4340.423)"
}, /*#__PURE__*/React.createElement("path", {
  className: "gpsa",
  d: "M1559.381,4358.116a.519.519,0,0,1-.367-.151,4.6,4.6,0,0,1,0-6.5.519.519,0,0,1,.733.733,3.561,3.561,0,0,0,0,5.037.518.518,0,0,1-.367.885Z",
  transform: "translate(-12.717 -9.005)"
}), /*#__PURE__*/React.createElement("path", {
  className: "gpsa",
  d: "M1598.481,4358.116a.518.518,0,0,1-.366-.885,3.562,3.562,0,0,0,0-5.037.519.519,0,0,1,.733-.733,4.6,4.6,0,0,1,0,6.5A.52.52,0,0,1,1598.481,4358.116Z",
  transform: "translate(-46.048 -9.005)"
}), /*#__PURE__*/React.createElement("path", {
  className: "gpsa",
  d: "M1544.782,4350.993a.519.519,0,0,1-.367-.151,7.268,7.268,0,0,1,0-10.267.519.519,0,0,1,.733.733,6.229,6.229,0,0,0,0,8.8.518.518,0,0,1-.367.885Z",
  transform: "translate(0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "gpsa",
  d: "M1609.368,4350.993a.518.518,0,0,1-.367-.885,6.23,6.23,0,0,0,0-8.8.519.519,0,0,1,.733-.733,7.269,7.269,0,0,1,0,10.267A.519.519,0,0,1,1609.368,4350.993Z",
  transform: "translate(-55.053)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "gpsa",
  cx: 1.61,
  cy: 1.61,
  r: 1.61,
  transform: "translate(1547.94 4344.098)"
}));

var SvgGps = function SvgGps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.512,
    height: 10.57,
    viewBox: "0 0 14.512 10.57",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gps.c0a61602.svg";
export { ForwardRef as ReactComponent };